<template>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">

        <!-- BEGIN: Subheader -->
        <div class="m-subheader ">
            <div class="d-flex align-items-center">
                <div class="mr-auto">
                    <h3 class="m-subheader__title m-subheader__title--separator" v-if="currentPage">{{ labels[menuOptions[currentPage].title]|capitalize }}</h3>
                    <ul class="m-subheader__breadcrumbs m-nav m-nav--inline" v-if="showTabMenu">
                        <li class="m-nav__item m-nav__item--home">
                            <router-link :to="{name: 'DashboardMain'}" class="m-nav__link m-nav__link--icon">
                                <i class="m-nav__link-icon la la-home"></i>
                            </router-link>
                        </li>
                        <template v-for="menu in menuOptions[currentPage].options" v-if="fullProductManagementAccess">
                            <li class="m-nav__separator">-</li>
                            <li class="m-nav__item">
                                <router-link :to="{ name: menu.routeName, query: menu.query }" class="content_nav">
                                    <span class="m-nav__link-text">{{ labels[menu.title] }}</span>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
        <!-- END: Subheader -->
        <!-- table router view -->
        <router-view name="table"></router-view>
        <router-view name="dashboardMain"></router-view>

        <modal-import></modal-import>

    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ModalImport from '../Modals/ModalImport';

export default {
  name: 'Content',
  components: {
    ModalImport,
  },
  data() {
    return {
      title: 'Add a new product',
      currentPage: '',
      showTabMenu: false,
      menuOptions: {
        stocks: {
          title: 'manage_stock_title',
          options: [
            {
              title: 'manage_stock_title',
              routeName: 'StockList',
            },
            {
              title: 'add_a_product_to_stock',
              routeName: 'ProductForm',
            },
          ],
        },
        products: {
          title: 'manage_products_title',
          options: [
            {
              title: 'manage_products_title',
              routeName: 'ProductList',
            },
            {
              title: 'create_a_product',
              routeName: 'ProductFormExt',
            },
          ],
        },
        cruds: {
          title: 'resources_title',
          options: [],
        },
        users: {
          title: 'manage_users_title',
          options: [],
        },
        segmentations: {
          title: 'manage_theme_segmentations',
          options: [],
        },
        exports: {
          title: 'manage_exports_title',
          options: [],
        },
      },
    };
  },
  watch: {
    $route(value) {
      this.managePageTitle;
    },
  },
  computed: {
    ...mapState([
      'labels',
    ]),
    ...mapGetters([
      'fullProductManagementAccess',
    ]),
    managePageTitle() {
      if (this.$route.path.indexOf('resources') !== -1) {
        this.currentPage = 'cruds';
        this.showTabMenu = false;
      } else if (this.$route.path.indexOf('stock') !== -1) {
        this.currentPage = 'stocks';
        this.showTabMenu = true;
      } else if (this.$route.path.indexOf('manage-products') !== -1) {
        this.currentPage = 'products';
        this.showTabMenu = true;
      } else if (this.$route.path.indexOf('manage-users') !== -1) {
        this.currentPage = 'users';
        this.showTabMenu = true;
      } else if (this.$route.path.indexOf('manage-exports') !== -1) {
        this.currentPage = 'exports';
        this.showTabMenu = true;
      } else if (this.$route.path.indexOf('amoire-technique') !== -1) {
        this.currentPage = 'segmentations';
        this.showTabMenu = true;
      } else {
        this.currentPage = '';
        this.showTabMenu = false;
      }
    },
  },
  created() {
    // Get the page name
    this.managePageTitle;
  },
};
</script>

<style>
    @import '../../assets/css/choices.min.css';

    .content_nav {
        color: #898b96;
    }
    .content_nav:hover {
        color: #1b7e9a;
    }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Content.vue